import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['bg', 'en', 'de'],

  // Primary site language — canonical production host loads `/bg` by default.
  defaultLocale: 'bg',

  // Always use locale prefix in URLs for SEO
  localePrefix: 'always',

  // Do not override defaultLocale from Accept-Language (e.g. German browsers).
  localeDetection: false,

  // Disable next-intl's automatic HTTP `Link` hreflang header.
  // With `localePrefix: 'always'`, that header sets `x-default` to the
  // unprefixed path (e.g. `/services/office-cleaning`), which 308/307s to
  // `/bg/…`. Google then lists those sources as "Page with redirect" and
  // keeps rediscovering them. Canonical hreflang lives in HTML metadata and
  // the sitemap via `buildHreflangAlternates` (`x-default` → `/bg/…`).
  alternateLinks: false,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, permanentRedirect } =
  createNavigation(routing);
